import { AxiosInstance, AxiosRequestConfig } from 'axios';
import generateRequestId from './generateRequestId';
import { ApiResponse, ApiError } from './types';

export async function apiRequest<T>(
  api: AxiosInstance,
  config: AxiosRequestConfig
): Promise<ApiResponse<T>> {
  const requestId = generateRequestId();
  console.log(`Begin API request with requestId: ${requestId}`);

  try {
    const response = await api.request({
      ...config,
      headers: {
        'X-Request-ID': requestId,
        ...config.headers,
      },
    });

    console.log(`End API request with requestId: ${requestId}`, response.data);

    return {
      data: response.data?.data as T,
      error: null,
    };
  } catch (error: any) {
    console.error(`Error in API request with requestId: ${requestId}`, error);

    let errorMessage = 'An unknown error occurred';

    // Handle different error scenarios
    if (error.response) {
      // Server responded with a status code outside the 2xx range
      errorMessage = error.response.data?.error || error.message;
    } else if (error.request) {
      // No response received
      errorMessage = 'No response from server';
    } else {
      // Other errors
      errorMessage = error.message;
    }

    const apiError: ApiError = {
      message: errorMessage,
      requestId,
    };

    return {
      data: null,
      error: apiError,
    };
  }
}